<!--  -->
<template>
  <div class="fhv-centent" v-loading="loading">
    <h4 class="title-topic">Schedule Reboot</h4>
    <el-alert
      title="Tips: This setting will only take effect where internet connection if accessible and the GMT time is configured correctly."
      type="warning"
      show-icon
      :closable="false"
    ></el-alert>
    <el-form
      label-width="180px"
      label-position="left"
      class="fhv-form"
      size="small"
      ref=""
      :disabled="$G_DEVICE_CFG.isReadOnly"
    >
    
      <!-- Status: -->
      <el-form-item label="Status:">
        <el-switch v-model="statusEnable"></el-switch>
      </el-form-item>

      <div v-if="statusEnable">

        <!-- Time -->
        <el-form-item label="Time:" >
            <el-time-picker
              style="position:absolute"
              v-model="timeStar"
              value-format="HH:mm"
              format='HH:mm'
              
            ></el-time-picker>
           
        </el-form-item>
       
        <!-- Day -->
        <el-form-item label="Day:">
            <el-checkbox-group style="width:560px" v-model="selectVal"  size="medium" @change="changeDayVal">
                <el-checkbox-button  v-for="(day, index) in days" :label="index" :key="day">{{day}}</el-checkbox-button>
                <el-checkbox-button @change="everyDayClick()" :label="7">EveryDay</el-checkbox-button>
            </el-checkbox-group>
        </el-form-item>
        </div>

        <!-- Save -->
        <el-form-item>
            <el-button type="primary" @click="setData()">Save</el-button>
        </el-form-item>
      
    </el-form>
  </div>
</template>

<script>
const allDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function getSelectDayVal(getSelectVal){
    let dayVal = [0,0,0,0,0,0,0]
 
    getSelectVal.forEach(e => {
        if(7 != e)
            dayVal[e] = 1
    });
    return dayVal.join("");
}

export default {
  data() {
    return {
      loading: false,
      statusEnable: false,
      timeStar: "00:00",  //时间默认值
      days: allDays,
      selectVal:[] //天数渲染默认值
    };
  },
  created() {
    this.getData();
  },
  methods: {
    everyDayClick(){
        this.selectVal = [0,1,2,3,4,5,6,7]  //点击everyday  全部选中
    },
    changeDayVal(val){
        if(this.selectVal.length < 8 && this.selectVal[this.selectVal.length - 1] === 7)  this.selectVal.pop()
    },
    getDataRep(dataTime){
        let days = dataTime.substring(0, 7);
        let hour = dataTime.substring(8, 10);   
        let min = dataTime.substring(11, 14);

        // 映射后端数据
        for(let i = 0; i < days.length; i++){
            if(days[i] === '1'){
                this.selectVal.push(i); //days渲染
            }
        }

        if(this.selectVal.length === 7) this.selectVal.push(7)

        this.timeStar = dataTime.substring(8,14); //time渲染   
    },
    getTimeDays(){
        let days = getSelectDayVal(this.selectVal);
        var setData = `${days}&${this.timeStar}`
        return setData;
    },
    getData() {
      this.loading = true;
      axios
        .post("/JSONAPI", { cmdType: "GET_WEB_SCHEDULEREBOOT" })
        .then(res => {
          this.loading = false;
          if (res.data.ret === 0) {
            this.statusEnable = res.data.enable;
            
            // 渲染time和day
            this.getDataRep(res.data.time);  //调函数分别渲染time和day
          } else{
              this.$message.error(
              `GET data failed!Error:${res.data.errMsg}`
            );
          } 
        })
        .catch(error => {
          this.loading = false;
          this.$message.error("GET data failed! Network connection error!");
        });
    },
    setData() {
      
      this.loading = true;
      axios
        .post("/JSONAPI", {
          cmdType: "SET_WEB_SCHEDULEREBOOT",
          enable: this.statusEnable,
          time: this.getTimeDays()
        })
        .then(res => {
          this.loading = false;
          if (res.data.ret === 0) {

            this.$message.success("SET Schedule Reboot success!");
          } else
            this.$message.error(
              `SET Schedule Reboot failed! Error:${res.data.errMsg}`
            );
        })
        .catch(error => {
          this.loading = false;
          this.$message.error(
            "SET Schedule Reboot failed! Network connection error!"
          );
        });
    }
  }
};
</script>
